import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccreditationGroupsList from "../AccreditationGroupsList/AccreditationGroupsList.container";
import DepartmentsList from "../departmentsList/DepartmentsList.container";
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';
import _ from 'lodash';

class GroupsManagementComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            successMessage: null
        }
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    render() {
        return (
            <FormWrapper successMessage={_.get(this.props.translation, this.state.successMessage)}>
            <div className="groups-management-container">
                <AccreditationGroupsList setSuccessMessage={this.setSuccessMessage}/>
                <div className="brain-chain-divider"/>
                <DepartmentsList setSuccessMessage={this.setSuccessMessage}/>
            </div>
            </FormWrapper>
        );
    }

    setSuccessMessage = (successMessage) => {
        this.setState({successMessage})
    }
}

GroupsManagementComponent.propTypes = {
    translation: PropTypes.object,
    onUnmount: PropTypes.func.isRequired
}

export default GroupsManagementComponent;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/groupsManagement/GroupsManagementComponent.js